/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Style from "./DoctorListing.module.scss";
import classNames from "classnames";
import DoctorSpecialities from "../DoctorSpecialities";
import Container from "react-bootstrap/Container";
import DoctorListingDetails from "../DoctorListingDetails";
import DoctorListingFilters from "../DoctorListingFilters";
import BookAppointment from "../BookAppointment";
import { useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import {
  fetch_doctors,
  fetch_doctors_v2,
} from "../../actions/DoctorListingAction";
import MobileFilter from "../FilterMobileScreen";
import Assets from "../Layout/Assets";
import Spinner from "react-bootstrap/Spinner";
import { fetchSpeciality } from "../../actions/SpecialityListingAction";
import {
  fetch_clientDetails,
  fetch_clientDetails_v2,
} from "../../actions/MicrositeAction";
import MicrositeFooter from "../MicrositeLayout/MicrositeFooter";
import { useQuery } from "react-query";
import { log } from "@opentok/client";

function DoctorListing({
  showFilter,
  setShowFilter,
  setSearchDoctor,
  searchDoctor,
  pagination,
  setPagination,
  selectedSpeciality,
  setSpeciality,
}) {
  const locationData = useSelector((state) => state.doctorListing.location);
  const languageData = useSelector((state) => state.doctorListing.languagesSet);
  const hospitalData = useSelector((state) => state.doctorListing.hospitals);
  const clientDetails = useSelector((state) => state.clientDetails);
  const theme = useSelector((state) => state.theme?.theme);

  let doctorListingScroll = useRef();
  let { speciality } = useParams();

  const [filterForm, setFilter] = useState({
    location: [],
    hospital: [],
    language: [],
    gender: "Gender",
    doctorName: "",
  });
const observerRef = useRef(null);
  const localClinicDetails = JSON.parse(localStorage.getItem("ClinicDetails"));
  const [filterKey, setFilterKey] = useState({ speciality: "ALL" });
  const [isDataLoaded, setDataLoaded] = useState(false);
  const [isDoctorsLoading, setDoctorsLoading] = useState(true);
  const [isBackLoading, setBackLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const [drListingResponse, setDrListingResponse] = useState(null);
  //const [pagination, setPagination] = useState(0);

  //React Query............................................................
  const query = useQuery(
    [`fetch_doctors_v2 ${selectedSpeciality}`],
    async (_clinicDetails) => {
      const data = await fetch_doctors_v2(
        selectedSpeciality,
        _clinicDetails?.clinicName || clientDetails?.clinicName || "",
        pagination
      );
      return data;
    },
    {
      enabled: false, // Set enabled to false to prevent initial execution
      cacheTime: 60000,
    }
  );

  useEffect(() => {
    const _filteredData = query?.data?.doctorDetails?.filter((item) => {
      if (filterKey) {
        const isSameDocName =
          filterKey["doctorName"] && filterKey["doctorName"] !== undefined
            ? item?.doctorFirstName
                .toLowerCase()
                .startsWith(filterKey["doctorName"].toLowerCase())
            : true;
        const isSelectedGender = filterKey["gender"]
          ? item?.gender.toLowerCase() === filterKey["gender"].toLowerCase()
          : true;

        const isSelectedHospital = filterKey["hospitalname"]
          ? filterKey["hospitalname"].includes(item?.hospitalname.toLowerCase())
          : true;
        const isSelectedCity = filterKey["city"]
          ? filterKey["city"].includes(item?.city.toLowerCase())
          : true;
        const isSelectedlanguages = filterKey["languages"]
          ? findCommonElements3(item?.languages, filterKey["languages"])
          : true;

        if (
          isSameDocName &&
          isSelectedGender &&
          isSelectedHospital &&
          isSelectedlanguages &&
          isSelectedCity
        ) {
          return item;
        }
      } else {
        return item;
      }
    });

    if (_filteredData) {
      setFilteredData(_filteredData);
    }
    if (clientDetails?.clinicName) {
      setDataLoaded(true);
      setDrListingResponse(query?.data);
      dispatch(
        fetch_doctors(
          speciality,
          clientDetails ? clientDetails.clinicName : "",
          // clientDetails ? clientDetails.clinicurl : "",
          pagination
        )
      );
    }
  }, [query?.data?.doctorDetails]);

  useEffect(() => {
    handleFilterChange();
  }, [filterKey]);

  //.......................................................................

  const specialityDataRedux = useSelector(
    (state) => state.specialityList.specialityList
  );

  const [specialityData] = useState(
    specialityDataRedux ? specialityDataRedux : []
  );

  function getFaviconEl() {
    return document.getElementById("favicon");
  }

  let { clinicId } = useParams();

  useEffect(() => {
    loadBackground(clientDetails);
    const favicon = getFaviconEl();
    favicon.href = clientDetails?.favicon;
    document.title = clientDetails?.clinicName;
  }, [selectedSpeciality, clientDetails]);

  const favicon = getFaviconEl(); // Accessing favicon element

  const loadInitialData = async () => {
    if (clinicId) {
      dispatch(
        fetch_clientDetails(clinicId === undefined ? "" : clinicId)
      );
      dispatch(
        fetchSpeciality(clinicId === undefined ? "" : clinicId)
      ).then(() => {
        query.refetch();
      });
    } else {
      loading();
      setDataLoaded(true);
    }
  };

  //Main useEffect.............................................................
  useEffect(() => {
    // if (clinicId && !clientDetails) {
    //   console.log(
    //     "Loading clinic id in use effect........................................................."
    //   );
    //   dispatch(
    //     fetch_clientDetails(clinicId === undefined ? "gericare" : clinicId)
    //   ).then((res) => {
    //     dispatch(
    //       fetchSpeciality(clinicId === undefined ? "gericare" : clinicId)
    //     ).then(() => {});

    //     setClinicDetails(res);
    //     setDataLoaded(true);
    //     loading(res);
    //     favicon.href = res.favicon;
    //     document.title = res.clinicName;
    //     loadBackground();
    //   });

    //   if (specialityData.length === 0) {
    //     dispatch(
    //       fetchSpeciality(clinicId === undefined ? "gericare" : clinicId)
    //     ).then(() => {});
    //   }
    // } else {
    //   loading(clientDetails);
    //   setDataLoaded(true);
    // }

    loadInitialData();
  }, []);

  const colSpecialityDiv = classNames(
    Style.doctor_listing_speciality_div,
    "col-md-3"
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setFilter({ ...filterForm, doctorName: searchDoctor });
    setFilterKey({ ...filterKey, doctorName: searchDoctor });
  }, [searchDoctor]);

   // Scroll event listener
   useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 10
      ) {
        //setPage((prevPage) => prevPage + 1);
        console.log("scrolling")
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const loading = async () => {
    if (selectedSpeciality !== "") {
      setDoctorsLoading(true);
      await query.refetch();
      setDoctorsLoading(false);
      // dispatch(
      //   fetch_doctors(
      //     selectedSpeciality,
      //     clientDetails ? clientDetails.clinicName : "",
      //     // clientDetails ? clientDetails.clinicurl : "",
      //     pagination
      //   )
      // ).then((res) => {
      //   setDataLoading(false);
      // });
    }
  };

  const loadBackground = async (clientDetails) => {
    setBackLoading(true);
    setDoctorsLoading(true);
    await query.refetch(clientDetails);
    setBackLoading(false);
    setDoctorsLoading(false);
  };

  const findCommonElements3 = (arr1, arr2) => {
    if (arr1 && !Array.isArray(arr1)) {
      arr1 = arr1?.split(/[ ,]+/);
    }

    let test = Array.isArray(arr1);
    if (test) {
      return arr1?.some((item) => arr2.includes(item));
    }
  };

  const ResetFilter = () => {
    setFilter({
      location: [],
      hospital: [],
      language: [],
      gender: "Gender",
      doctorName: "",
    });
    setFilterKey(null);

    hospitalData.map((data) => ({ ...data, checked: false }));
    locationData.map((data) => ({ ...data, checked: false }));
    locationData.map((data) => ({ ...data, checked: false }));
    languageData.map((data) => ({ ...data, checked: false }));
  };

  let onScrollDoctorList = async () => {
    const { scrollTop, scrollHeight, clientHeight } =
      doctorListingScroll.current;

    if (scrollTop + clientHeight === scrollHeight) {
      // TO SOMETHING HERE
      console.log("Reached bottom");
      setPagination(pagination+1)
      query.refetch();
      // if (FilterItem.length % 4 == 0) {

      // await setLoader(true);
      /*  await dispatch(
        fetch_doctors(
          selectedSpeciality,
          clientDetails ? clientDetails.clinicName : "",
          // clientDetails ? clientDetails.clinicurl : "",
          pagination + 10
        )
      );
      setPagination(pagination + 10) */
      // await setLoader(false);

      // }
    }
  };

  function checkForLoading() {
    if (!isDataLoaded || query?.isLoading || !query.isFetched) {
      return true;
    } else {
      return false;
    }
  }

  function handleFilterChange() {
    const FilterItem = query?.data?.doctorDetails?.filter((item) => {
      if (filterKey) {
        const isSameDocName =
          filterKey["doctorName"] && filterKey["doctorName"] !== undefined
            ? item?.doctorFirstName
                .toLowerCase()
                .startsWith(filterKey["doctorName"].toLowerCase())
            : true;
        const isSelectedGender = filterKey["gender"]
          ? item?.gender.toLowerCase() === filterKey["gender"].toLowerCase()
          : true;
        const isSelectedHospital = filterKey["hospitalname"]
          ? filterKey["hospitalname"].includes(item?.hospitalname.toLowerCase())
          : true;
        const isSelectedCity = filterKey["city"]
          ? filterKey["city"].includes(item?.city.toLowerCase())
          : true;
        const isSelectedlanguages = filterKey["languages"]
          ? findCommonElements3(item?.languages, filterKey["languages"])
          : true;
        if (
          isSameDocName &&
          isSelectedGender &&
          isSelectedHospital &&
          isSelectedlanguages &&
          isSelectedCity
        ) {
          return item;
        }
      } else {
        return item;
      }
    });
    setFilteredData(FilterItem);
  }

  return !showFilter ? (
    <div className={Style.doctor_listing_topSection}>
      <Container className="h-100">
        <div
          className={`${Style.doctorListWrap} ${
            theme === "Arabic" ? `, ${Style.doctorListWrapArabic}` : ""
          }`}
        >
          <div className={colSpecialityDiv}>
            <h2 className={Style.doctor_listing_main_heading}>Specialities</h2>
            <DoctorSpecialities
              selectedSpeciality={selectedSpeciality}
              setSpeciality={setSpeciality}
              clientDetails={clientDetails}
              ResetFilter={ResetFilter}
            />
          </div>

          <div className={`${Style.doctorListFilter} doctor_ListFilter`}>
            {!isMobile && (
              <DoctorListingFilters
                drListingResponse={drListingResponse}
                filterForm={filterForm}
                setFilter={setFilter}
                setFilterkey={setFilterKey}
                filterKey={filterKey}
                ResetFilter={ResetFilter}
                clientDetails={clientDetails}
              />
            )}
            <div
              className={Style.doctor_listing_scrolling}
              ref={doctorListingScroll}
              onScroll={() => {
                onScrollDoctorList();
              }}
            >
              {checkForLoading() ? (
                <div className={Style.loader}>
                  <Spinner
                    style={{ width: "4rem", height: "4rem" }}
                    animation="border"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : filteredData && filteredData.length !== 0 ? (
                filteredData.map((item, index) => {
                  return <DoctorListingDetails Details={item} key={index} />;
                })
              ) : (
                <div className={Style.NoDataFound}>
                  <img src={Assets.nodataFound} alt="" />
                  <p className={Style.text}>There is nothing to display here</p>
                </div>
              )}

              {filteredData &&
                filteredData.length !== 0 &&
                !query.isLoading && (
                  <div style={{ width: "100%", marginTop: "29px" }}>
                    <MicrositeFooter small />
                  </div>
                )}
            </div>
          </div>
          <BookAppointment></BookAppointment>
        </div>
      </Container>
    </div>
  ) : (
    <MobileFilter
      showFilter={showFilter}
      setShowFilter={setShowFilter}
      filterForm={filterForm}
      setFilter={setFilter}
      setFilterkey={setFilterKey}
      filterKey={filterKey}
      clientDetails={clientDetails}
      // setSearchDoctor={setSearchDoctor}
      // searchDoctor={searchDoctor}
    />
  );
  //<MobileBookAppointment/>
}

export default DoctorListing;
